
import { Chip, Stack } from '@mui/material';
import React from 'react';
import { TagsProps } from './helper';
import { blankClick } from '../../helper/functions';
const Tags = ({ collection, spacing = .5 }: TagsProps): JSX.Element =>
(
    <Stack spacing={spacing} direction="row" flexWrap="wrap">

        {
            collection.map((e, i) =>
            (
                <Chip variant="outlined" key={i} label={e} onClick={blankClick} />
            ))
        }
    </Stack>
)

export default Tags;
